'use client';

import { createContext, useContext } from 'react';

// Whether the rows on show had their EV cut (the board's payload was served without projections): their EV slots
// then show the blurred "sign up to see EV" teaser instead of blank. A property of the data, not the viewer: the
// landing demo renders the same rows with its EV, under no provider, and never teases.
const EvTeaseContext = createContext(false);

export const EvTeaseProvider = EvTeaseContext.Provider;

export function useEvTease(): boolean {
  return useContext(EvTeaseContext);
}
